import { browser } from "$app/environment"
import { API_URL, APP_VERSION } from "$lib/env"
import axios from "axios"

const httpClient = axios.create({
  baseURL: API_URL,
  headers: {
    "accept": "application/json",
    "device-id": "",
    "device-name": "",
    "device-version": "",
    "device-region-id": "",
    "device-region-offset": "",
    "app-version": APP_VERSION,
  },
  withCredentials: true,
  withXSRFToken: true,
  timeout: 120_000,
  validateStatus: (status) => ![222, 404, 408, 429, 500, 502, 503, 504].includes(status)
})

httpClient.interceptors.request.use(
  (config) => {

    if (config.url) {
      config.url = config.url.replace(/\/+$/, "")
    }

    return config
  }
)

httpClient.interceptors.response.use(
  (response) => {

    if (!browser) {
      return Promise.reject(new Error("Unrecognize Browser"))
    }

    if (response.status == 207) {

      window.dispatchEvent(
        new CustomEvent("redirect", {
          detail: {
            target: response.data.result,
            message: response.data.message,
          }
        })
      )

      return Promise.reject(new Error("Redirect"))
    }

    if (
      response.status == 400
    ) {
      return Promise.reject(new Error(response.data.message))
    }

    if (
      response.status == 401 &&
      response.config.url != "/api/auth/data"
    ) {
      window.dispatchEvent(new Event("auth-logout"))
      return Promise.reject(new Error("Akun dikeluarkan oleh sistem"))
    }

    if (
      response.status == 422
    ) {
      return Promise.reject(new Error(response.data.message))
    }

    if (
      response.status == 403
    ) {
      return Promise.reject(new Error(response.data.message))
    }

    return response
  },
  (data) => {

    if (data.code == "ERR_NETWORK") {

      return Promise.reject(new ErrorConnection(
        "Gagal terhubung, Pastikan internet / perangkat utama aktif"
      ))
    }

    if (data.code == "ECONNABORTED") {

      return Promise.reject(new ErrorConnection(
        "Jaringan tidak stabil, proses ini memerlukan jaringan internet stabil"
      ))
    }

    if (data.response.data?.message) {
      return Promise.reject(new Error(data.response.data?.message))
    }

    return Promise.reject(data)
  }
)

export class ErrorConnection extends Error {
}

export class ErrorAuthorization extends Error {
}

export default httpClient
